<template>
  <div>
    <h1>Manage Users</h1>
    <div class="mt-5">
      <v-card-actions>
        <div class="mx-auto">
          <v-btn :to="{ path: '/okta-users' }" color="primary">Add New User</v-btn>
        </div>
      </v-card-actions>
      <manage-users-tabs :user-list="userList" :user-groups="userGroups" :selected-user="login" />
    </div>
  </div>
</template>

<script>
import ManageUsersTabs from '@/components/manageUsers/ManageUsersTabs'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'manage-users',
  components: {
    ManageUsersTabs
  },
  props: {
    login: String
  },
  computed: {
    ...mapState('manageUsers', ['userList', 'userGroups'])
  },
  created() {
    this.getUsers()
    this.getUserGroups()
  },
  methods: {
    ...mapActions('manageUsers', ['getUsers', 'getUserGroups'])
  }
}
</script>
